(ns motorsaif.web.components.side-menu
  (:require
   ["react-transition-group" :refer [CSSTransition Transition TransitionGroup SwitchTransition]]
   ["react" :as react]
   [reagent.ratom :as ra]
   [motorsaif.web.pwa :as pwa]
   [reagent.core :as r]
   [motorsaif.frontend-routes :as routes]
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.web.components :as c]
   [motorsaif.utils :as utils]
   [re-frame.core :as rf :refer [dispatch subscribe]]))

(defn current-owner-selector []
  (let [trs (i18n/tr-scope [:side-menu :role-selector])
        user @(subscribe [:user])
        {user-id :db/id :user/keys [handle email]} user
        ;; ?roles (mapv (fn [{db-id :db/id biz-name :business/name :as role}]
        ;;                {:on-click #(dispatch [:swap-current-owner db-id biz-name])
        ;;                 :biz-id db-id
        ;;                 :title biz-name})
        ;;              (map second ?roles))
        ?roles @(subscribe [:business-roles])
        current-owner-id @(subscribe [:current-owner-id])

        unread @(subscribe [:user-unread-by-roles])
        role-item (fn [{:keys [handle id unread]}]
                    (let [current? (= id current-owner-id)]
                      [:li.list-item.small
                       (if current?
                         {:class "active"}
                         {:on-click #(dispatch [:swap-current-owner id])})
                       [:div.personal
                        [:div.name handle]
                        #_[:div.email email]]
                       (when (> unread 0)
                         [:span.unread unread])]))]
    (fn []
      (when (> (count (seq ?roles)) 0)
        [:div#account-selector
         [:hr]
         [:section
          [:div.header (trs :personal "Personal Account")]
          [:div.list-item.small
           {:on-click #(dispatch [:swap-current-owner user-id])
            :class (when (= user-id current-owner-id) "active")}
           handle]]
         [:section
          [:div.header (trs :business "Business Accounts")]
          (into [:ul]
                (map (fn [itm]
                       (let [{id :db/id
                              biz-name :business/name
                              email :business/email} itm
                             unread (get unread id)]
                         [role-item {:id id
                                     :unread unread
                                     :handle biz-name}]))
                     (map second ?roles)))]]))))


(defn main []
  (let [user @(subscribe [:user])
        {user-id :db/id
         :user/keys [handle email]} user
        *current-owner (subscribe [:current-owner])
        ref (react/createRef)
        trs (i18n/tr-scope [:side-menu])
        ]
    (r/create-class
      {
       :component-did-mount
       (fn []
         #_(utils/set-root-property :nav-height
                                    (str (.-clientHeight (.-current ref)) "px")))
       :reagent-render
       (fn []
         (let [active (:name (:data @(rf/subscribe [:route/data])))
               ?roles @(subscribe [:business-roles])
               ?roles (mapv (fn [{db-id :db/id biz-name :business/name :as role}]
                              {:value db-id
                               :title
                               (trs [:business-accounts]
                                    "%1 - Business Account"
                                    [biz-name]
                                    )
                               #_(format "%s - Business Account" biz-name)})
                            (map second ?roles))
               is-business? @(subscribe [:is-business?])]
           [:div#side-menu
            {:ref ref}
            [:div.inner
             [:div.top
              [c/avatar-letter-with-link {:owner @*current-owner
                                          :letter-class "large"}]
              [:div.mid
               [:span.handle (utils/owner-handle @*current-owner)]
               [:div.email email]]]
             (when (seq ?roles)
               [current-owner-selector])
             [:hr]
             [:section
              [:div.header
               (trs :settings "Settings")]
              [:ul.links
               (for [[k icon title]
                     (->> [[:settings-profile
                            [:i.fa.fa-address-card]
                            (trs :profile "Profile")]

                           (when is-business?
                             [:settings-business
                              [:i.fa-solid.fa-pen-to-square]
                              (trs :business-profile "Business Profile")])

                           [:settings-notifications
                            [:i.fal.fa-envelope]
                            (trs :notifications "Notifications")]

                           (when @(subscribe [:is-admin?])
                             [:admin
                              [:i.fal.fa-hammer]
                              (trs :admin "Admin")])]
                          (remove nil?))]
                 ^{:key k}
                 [:li
                  {:class
                   (utils/cond-css
                    true (name k)
                    (= active k) "active"
                    (and (= k :dash-notifications) (pwa/can-sub?)) "notification")}
                  [:a.list-item
                   {:href (routes/path-for k)
                    :class (name k)}
                   icon
                   [:span title]]])
               (when @(subscribe [:is-admin?])
                 [:li
                  [:a.list-item
                   {:class (when @(rf/subscribe [:admin-overlay]) " active")
                    :on-click #(rf/dispatch [:set-ui-state
                                             :admin-overlay
                                             (fnil (fn [old] (not old)) false)])}
                   [:i.fal.fa-square-info]
                   [:span "Show Admin Info"]]])]]

             [:hr]
             
             ;; Theme Selector Accordion
             (let [themes-expanded @(rf/subscribe [:ui-state :themes-expanded])]
               [:section.accordion
                [:button.list-item.reset-button.click-wrap
                 {:on-click #(rf/dispatch [:set-ui-state :themes-expanded (not themes-expanded)])}
                 [:i.fas.fa-palette]
                 [:span "Theme"]
                 [:i.fas {:class (if themes-expanded "fa-chevron-up" "fa-chevron-down")}]]
                (when themes-expanded
                  ^{:key
                    (str @(rf/subscribe [:current-theme]))}
                  [:ul.links.theme-list
                   (for [[theme-base theme-name colors] [["default" "Default" ["#2A69E7" "#DA4278" "#5E6D85" "#34D399"]]
                                                         ;; ["nordic" "Nordic" ["#5B73F5" "#6B7889" "#96A2B4" "#A3BE8C"]]
                                                         ["tokyo" "Tokyo" ["#3D59A1" "#F7768E" "#9ECE6A" "#E0AF68"]]
                                                         ["aurora" "Aurora" ["#8B5CF6" "#14B8A6" "#6366F1" "#F59E0B"]]
                                                         ["woman" "Femme" ["#E91E63" "#FF6B9D" "#B39DDB" "#FF9800"]]
                                                         ["catppuccin" "Catppuccin" ["#1e66f5" "#8839ef" "#40a02b" "#df8e1d"]]]]
                     ^{:key theme-base}
                     [:li.theme-group
                      [:span.theme-name theme-name]
                      [c/tabs-section
                       {:tabs [{:key "light" :content "Light"}
                               {:key "dark" :content "Dark"}]
                        :class "clean compact"
                        :active-tab (let [current-theme @(rf/subscribe [:current-theme])]
                                      (cond
                                        (= current-theme (str "theme-" theme-base "-light")) "light"
                                        (= current-theme (str "theme-" theme-base "-dark")) "dark"
                                        :else nil)) ; No active tab if different theme is selected
                        :on-tab-click (fn [tab-key]
                                        (rf/dispatch [:theme/set (str "theme-" theme-base "-" tab-key)]))}]
                      [:div.color-preview
                       (for [color (take 3 colors)]
                         ^{:key color}
                         [:div.color-square
                          {:style {:background-color color}}])]])])])
             
             [:hr]
             
             ;; Font Size Selector
             [:section
              [:div.header "Font Size"]
              (let [current-font-size @(rf/subscribe [:current-font-size])]
                [c/tabs-section
                 {:tabs [{:key "small" :content "S"}
                         {:key "medium" :content "M"}
                         {:key "large" :content "L"}]
                  :active-tab current-font-size
                  :on-tab-click #(rf/dispatch [:font-size/set %])
                  :class "three-column clean"}])]
             
             [:hr]
             ;; [c/lang-selector]

             (when pwa/installable?
               [:a.list-item
                {:on-click #(rf/dispatch [:set-ui-state :install-pwa true])}
                [:i.fas.fa-download]
                "Install"])

             [:a.list-item
              {:href (routes/path-for :business-sign-up)}
              [:i.fa.fa-briefcase]
              (trs :create-business "Create Business")]
             [:button.list-item.reset-button
              {:on-click #(rf/dispatch [:logout])}
              [:i.fa-regular.fa-arrow-right-from-bracket]
              (trs :logout "Logout")]]]))})))

(comment
  (rf/subscribe [:ui-state :admin-overlay])
  (rf/subscribe [:admin-overlay])
  (rf/dispatch [:set-ui-state
                :admin-overlay
                (fnil (fn [old] (not old)) false)]))

;; (rf/subscribe [:ui-state :admin-overlay])

;; (update {} :test (fnil (fn [old] (not old)) false))

(defn side-menu []
  (let [*side-menu (subscribe [:ui-state :side-menu-open])
        *page (rf/subscribe [:route/page])]
    (fn []
      ;; Close side menu on page nav
      (let [curr-page @*page]
        @(ra/reaction
           (when (not= @*page curr-page)
             (rf/dispatch [:set-ui-state :side-menu-open false]))))
      [:> CSSTransition
       {:timeout 200
        :in @*side-menu
        :unmount-on-exit true
        :class-name  "menu-wrapper"
        :class-names "fade-toggle"}
       [:div
        [:div#side-menu-wrap.right
         [:div#overlay
          {:on-click #(rf/dispatch [:set-ui-state :side-menu-open false])}]
         [main]]]])))


;; fade-toggle-exit-active
;; fade-toggle-exit-done
